var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_165_137",
    "data-name": "Component 165 \\u2013 137",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10135",
    "data-name": "Rectangle 10135",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24481",
    "data-name": "Group 24481",
    transform: "translate(-487.548 -220.345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M499.548,237.8c5.339,0,7.81-.676,8.048-3.387,0-2.71-1.722-2.536-1.722-5.861,0-2.6-2.5-5.552-6.326-5.552s-6.326,2.955-6.326,5.552c0,3.324-1.722,3.151-1.722,5.861C491.74,237.133,494.21,237.8,499.548,237.8Z",
    transform: "translate(0 1)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_11893",
    "data-name": "Path 11893",
    transform: "translate(495.457 235.086)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.917,4.3c0,1.822-1.772,3.3-3.959,3.3S0,6.118,0,4.3,7.917,2.473,7.917,4.3Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.958500385284424 4.428935527801514 C 2.809220314025879 4.428935527801514 2.001215934753418 4.592953681945801 1.577768802642822 4.735826969146729 C 1.854068756103516 5.506664752960205 2.83245849609375 6.094945430755615 3.958500385284424 6.094945430755615 C 5.084542274475098 6.094945430755615 6.062932014465332 5.506664752960205 6.339231967926025 4.735826969146729 C 5.91578483581543 4.592953681945801 5.107780456542969 4.428935527801514 3.958500385284424 4.428935527801514 M 3.958500385284424 2.928932666778564 C 5.937750339508057 2.928932666778564 7.917000293731689 3.384480476379395 7.917000293731689 4.295575618743896 C 7.917000293731689 6.117765426635742 6.144720554351807 7.594945430755615 3.958500385284424 7.594945430755615 C 1.772280216217041 7.594945430755615 4.76837158203125e-07 6.117765426635742 4.76837158203125e-07 4.295575618743896 C 4.76837158203125e-07 3.384480476379395 1.979250431060791 2.928932666778564 3.958500385284424 2.928932666778564 Z",
    stroke: "none",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11894",
    "data-name": "Path 11894",
    d: "M277.747,409.443h1",
    transform: "translate(90.104 501.186) rotate(-90)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/IconNotification.b2dce9b6.svg";
export { ForwardRef as ReactComponent };